document.addEventListener("DOMContentLoaded", function () {
  /**
   * Override Quick Shop to fix preloading & init
   */
  theme.initQuickShop = function (scope) {
    scope = scope || document;
    var products = scope.querySelectorAll(".grid-product");

    if (!products.length || !theme.settings || !theme.settings.quickView) return;

    products.forEach((product) => {
      if (product.dataset.quickshopBound === "true") return;

      function productMouseover(evt) {
        var el = evt.currentTarget;
        if (!theme.config.bpSmall) {
          el.removeEventListener("mouseover", productMouseover);
          el.removeEventListener("focusin", productMouseover);

          if (!el || !el.dataset.productId) return;

          var productId = el.dataset.productId;
          var handle = el.dataset.productHandle;
          var btn = el.querySelector(".quick-product__btn");

          try {
            theme.preloadProductModal(handle, productId, btn);
          } catch (err) {
            console.warn("preloadProductModal error:", err);
          }
        }
      }

      product.addEventListener("mouseover", productMouseover);
      product.addEventListener("focusin", productMouseover);
      product.dataset.quickshopBound = "true";
    });
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    try {
      var holder = document.getElementById("QuickShopHolder-" + handle);
      if (!holder) {
        console.warn("QuickShop holder missing for", handle);
        return;
      }

      if (holder.dataset.loaded === "true") {
        if (btn) btn.classList.remove("quick-product__btn--not-ready");
        return;
      }

      var url = (theme.routes?.home || "") + "/products/" + handle + "?view=modal";
      url = url.replace(/\/\/+/g, "/");

      fetch(url, { credentials: "same-origin" })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;

          const div =
            html.querySelector('.product-section[data-product-handle="' + handle + '"]') ||
            html.querySelector('[data-product-handle="' + handle + '"]') ||
            html.querySelector(".product");

          holder.innerHTML = "";
          holder.appendChild(div || html);
          holder.dataset.loaded = "true";

          try {
            new theme.Modals("QuickShopModal-" + productId, "quick-modal-" + productId);
            theme.sections.register("product", theme.Product, holder);
          } catch (e) {
            console.warn("QuickShop init error", e);
          }

          try {
            theme.collapsibles.init(holder);
          } catch (e) {}
          try {
            theme.videoModal();
          } catch (e) {}

          if (btn) btn.classList.remove("quick-product__btn--not-ready");
        })
        .catch((err) => console.error("QuickShop preload failed for", handle, err));
    } catch (err) {
      console.error("Unexpected preload error", err);
    }
  };

  /**
   * Reinit scripts within a scope and append the modal shell
   */
  function reinitLoop(scope, skipSectionReinit) {
  scope = scope || document;

  // Reinit the original theme scripts (scope-aware)
  if (typeof theme.reinitProductGridItem === "function")
    theme.reinitProductGridItem(scope);
  if (theme.collapsibles && typeof theme.collapsibles.init === "function")
    theme.collapsibles.init(scope);
  if (typeof theme.videoModal === "function") theme.videoModal();
  if (!skipSectionReinit && theme.sections && typeof theme.sections.reinit === "function")
    theme.sections.reinit("collection-grid");

  // Bind Quick Shop for the new scope
  if (typeof theme.initQuickShop === "function") theme.initQuickShop(scope);

  // Append the modal shell for new products (with fallback selectors)
  scope.querySelectorAll(".grid-product").forEach((card) => {
    const id = card.dataset.productId;
    const handle = card.dataset.productHandle;
    if (!id || !handle) return;

    // find a valid parent section to insert the modal into
    let sectionEl =
      card.closest("[id^='CollectionSection-']") ||          // legacy section id
      card.closest("[data-section-id]") ||                   // collection page wrapper
      card.closest(".collection-content") ||                 // collection page class
      document.getElementById("CollectionAjaxContent") ||    // specific wrapper in your main-collection.liquid
      card.closest(".page-width") ||                         // fallback common container
      document.body;                                        // last-resort generic fallback

    // skip if the modal already exists
    if (document.getElementById("QuickShopModal-" + id)) return;

    // append next to sectionEl if present, otherwise append to body
    const modalHTML = `
      <div id="QuickShopModal-${id}" class="modal modal--square modal--quick-shop" data-product-id="${id}">
        <div class="modal__inner">
          <div class="modal__centered">
            <div class="modal__centered-content">
              <div id="QuickShopHolder-${handle}"></div>
            </div>
            <button type="button" class="modal__close js-modal-close text-link">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg>
              <span class="icon__fallback-text">"Close (esc)"</span>
            </button>
          </div>
        </div>
      </div>`;

    try {
      // if sectionEl is a block element (e.g. .collection-content), insert after it
      if (sectionEl && sectionEl.insertAdjacentHTML) {
        sectionEl.insertAdjacentHTML("afterend", modalHTML);
      } else {
        document.body.insertAdjacentHTML("beforeend", modalHTML);
      }
    } catch (err) {
      // safe fallback
      document.body.insertAdjacentHTML("beforeend", modalHTML);
      console.warn("QuickShop append fallback used for product", id, err);
    }

    // NOTE: do not bulk-preload here - hover preloading is handled by theme.initQuickShop(scope)
  });
}


  function bindPagination(paginationEl) {
    if (paginationEl.dataset.ajaxinateBound === "true") return;
    paginationEl.dataset.ajaxinateBound = "true";

    const sectionId = paginationEl.id.replace("featured-collection-Pagination-", "");
    const containerSelector = "#featured-collection-Loop-" + sectionId;
    const paginationSelector = "#featured-collection-Pagination-" + sectionId;
    let currentPage = 1;

    const showLessBtn = paginationEl.querySelector(".show-less");
    if (showLessBtn) showLessBtn.style.display = "none";

    function initAjaxinate() {
      return new Ajaxinate({
        container: containerSelector,
        pagination: paginationSelector,
        method: "click",
        loadingText: "Loading...",
      });
    }

    let endlessScroll = initAjaxinate();

    document.addEventListener("ajaxinate:loaded", function (e) {
      if (!paginationEl.contains(e.target)) return;

      currentPage++;
      const btn = paginationEl.querySelector(".show-less");
      if (btn) btn.style.display = "inline-block";

      const container = document.querySelector(containerSelector);
      reinitLoop(container);
    });

    paginationEl.addEventListener("click", function (e) {
      if (!e.target.matches(".show-less")) return;
      e.preventDefault();

      const container = document.querySelector(containerSelector);
      const sectionWrapper = container.closest("[id^='CollectionSection-']") || container;
      const sectionTop = sectionWrapper.getBoundingClientRect().top + window.scrollY;

      const params = new URLSearchParams(window.location.search);
      params.set("page", "1");
      params.set("section_id", sectionId);
      const firstPageUrl = window.location.pathname + "?" + params.toString();

      fetch(firstPageUrl, { credentials: "same-origin" })
        .then((res) => {
          if (!res.ok) return Promise.reject("HTTP " + res.status);
          return res.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const newContainer = doc.querySelector(containerSelector);
          const newPagination = doc.querySelector(paginationSelector);

          if (!newContainer) return Promise.reject("missing " + containerSelector);

          container.innerHTML = newContainer.innerHTML;
          if (newPagination) paginationEl.innerHTML = newPagination.innerHTML;

          currentPage = 1;

          const newShowLess = paginationEl.querySelector(".show-less");
          if (newShowLess) newShowLess.style.display = "none";

          reinitLoop(container);
          endlessScroll = initAjaxinate();

          window.scrollTo({
            top: sectionTop,
            behavior: "smooth",
          });
        })
        .catch((err) => {
          console.warn("[collection-ajaxinate] 'View less' failed:", err);
        });
    });
  }

  var loopObservers = [];

  function bindLoopObserver(loop) {
    if (loop.dataset.ajaxinateObserved === "true") return;
    loop.dataset.ajaxinateObserved = "true";

    const mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) reinitLoop(loop);
      });
    });
    mo.observe(loop, { childList: true });
    loopObservers.push({ observer: mo, el: loop });
  }

  function bindAll(isReload) {
    loopObservers = loopObservers.filter(function (entry) {
      if (document.contains(entry.el)) return true;
      entry.observer.disconnect();
      return false;
    });

    document
      .querySelectorAll("[id^='featured-collection-Pagination-']")
      .forEach(bindPagination);
    document
      .querySelectorAll('[id^="featured-collection-Loop-"]')
      .forEach(bindLoopObserver);

    reinitLoop(document, isReload);
  }

  bindAll(false);
  document.addEventListener("collection:reloaded", function () {
    bindAll(true);
  });
});
